// removed by extract-text-webpack-plugin
module.exports = {"loadingResults":"_3NtTed3tiq49mBusWOL97q"};


//////////////////
// WEBPACK FOOTER
// ./src/components/LoadingResultsTitle/LoadingResultsTitle.scss
// module id = 1605
// module chunks = 0